import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'

export enum ConceptAlertType {
  QUESTION_CONCEPT_ALERT = 'question_concept_alert',
  CONCEPT_DESCRIPTION_ALERT = 'concept_description_alert',
  PROFILE_CONCEPT_ALERT = 'profile_concept_alert'
}

export interface IConceptAlertStatus {
  concept_description_dismissed_date: string;
  question_concept_dismissed_date: string;
  profile_concept_dismissed_date: string;
}

export function conceptAlertFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/concept-alert'
  const methods = {
    getConceptAlertStatus() {
      return api.get<IConceptAlertStatus>(baseUrl)
    },
    dismissConceptAlert(type: ConceptAlertType) {
      return api.post<IConceptAlertStatus>(baseUrl, { type })
    }
  }
  return createOptimizedAPI(methods)
}
